<template>
  <bill-card :header="header">
    <a-spin :spinning="loading">
      <a-card style="height: auto">
        <e-chart
          domId="bill-predict-2"
          :options="chartOptions"
          chartStyle="width:100%;height: 202px"
          autoresize
          :showCustomLegend="isTemplate"
          @chartInstance="chartCreate" />
      </a-card>
    </a-spin>
  </bill-card>
</template>

<script>
import { numerify } from '@/filters'
import { getChartTooltipPosition } from '@/utils/echart'

export default {
  name: 'BillPredict2',
  props: {
    header: Object,
    categoryArr: Array,
    seriesArr: Array,
    loading: Boolean,
    currencySign: String,
    chartColors: Array,
    dataType: String,
    getNameI18n: Function,
    isTemplate: Boolean,
  },
  inject: ['inBaseSidePage'],
  data () {
    return {
    }
  },
  computed: {
    timeFormat () {
      if (this.dataType) {
        if (this.dataType.includes('month')) {
          return 'YYYY-MM'
        }
        if (this.dataType.includes('day')) {
          return 'MM-DD'
        }
      }
      return 'YYYY-MM-DD'
    },
    chartOptions () {
      const seriesArr = Array.isArray(this.seriesArr) ? this.seriesArr : []
      const categoryArr = Array.isArray(this.categoryArr) ? this.categoryArr : []
      const series = seriesArr.filter(item => item && Array.isArray(item.data)).map(item => {
        const ret = {
          name: item.name,
          type: 'bar',
          data: item.data,
          z: 0,
          barGap: '-100%',
        }
        if (item.isStackAd) {
          ret.stack = 'Ad'
        }
        if (item.isPredict) {
          ret.itemStyle = {
            color: '#DEDFE3',
          }
        }
        if (item.isOther) {
          ret.itemStyle = {
            color: '#616161',
          }
        }
        return ret
      })
      const xAxisData = categoryArr.filter(item => item && item.time).map(item => this.$moment(String(item.time).replace('TZ', '')).format(this.timeFormat))
      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        title: {
          show: true,
          text: this.header.title,
          textStyle: {
            fontSize: '14px',
            fontWeight: 'normal',
          },
        },
        legend: {
          show: !this.isTemplate,
          width: '75%',
          type: 'scroll',
          formatter: (name) => {
            if (name === '__others__') return this.$t('bill.other')
            return this.getNameI18n(name)
          },
        },
        color: this.chartColors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgb(77, 161, 255)',
              opacity: 0.1,
            },
          },
          position: (point, params, dom, rect, size) => {
            dom.style.border = 'none'
            dom.style.backgroundColor = 'transparent'
            let series = params
            series.sort((a, b) => b.value - a.value)
            series = series.map((line, index) => {
              if (line.value === undefined || line.value === 0.0 || line.value === '') {
                return ''
              }
              const name = line.seriesName
              return `<div style="color: #616161;">${line.marker} <span>${this.getNameI18n(name)}</span>:  <span>${this.currencySign} ${numerify(line.value, '0,0.00')}</span></div>`
            }).join('')
            if (series.length === 0) {
              dom.innerHTML = ''
              return
            }
            const wrapper = `<div class="chart-tooltip-wrapper">
                          <div style="color: #5D6F80;">${params[0].name}</div>
                          <div class="lines-wrapper">${series}</div>
                        </div>`
            dom.innerHTML = wrapper
            return getChartTooltipPosition(point, dom, size, this.inBaseSidePage)
          },
        },
        toolbox: {
          feature: {
            magicType: { show: true, type: ['line', 'bar'] },
          },
        },
        series: series,
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              return `${this.currencySign} ${value}`
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        barMaxWidth: 30,
      }
    },
  },
  methods: {
    chartCreate (chart) {
      const that = this
      chart.on('legendselectchanged', function (params) {
        const { selected = {} } = params
        that.$emit('selectedChange', selected)
      })
    },
  },
}
</script>
